module.exports = __webpack_public_path__ + "img/man-plain.05c0e9f9.svg";